import { ReactNode } from 'react';

interface SectionHeaderProps {
  title: string;
  actions?: ReactNode;
  /** Nested sub-section bars render slightly smaller/lighter than a top-level one, so a workspace with several nested sections stays readable rather than repeating the same heavy bar. */
  nested?: boolean;
}

/**
 * The solid-bar section header from the OneGMS reference, translated
 * to VConnect's own institutional blue (--color-primary) rather than
 * an arbitrary teal - real, existing design tokens, not a new color
 * invented for this one component. Used for any card/panel that
 * benefits from a stronger visual anchor than a plain <h2>; ordinary
 * cards can keep the plain heading where a solid bar would be
 * overkill (per the brief: not every section needs this treatment).
 */
export function SectionHeader({ title, actions, nested }: SectionHeaderProps) {
  return (
    <div className={nested ? 'section-header-bar section-header-bar-nested' : 'section-header-bar'}>
      <h2>{title}</h2>
      {actions && <div className="section-header-actions">{actions}</div>}
    </div>
  );
}
